import React, { useState, useContext, useEffect } from 'react'
import ErrorAlert from './common/ErrorAlert'
import { PasswordService } from '../services/password-service'
import { SsoCard } from './common/sso-card'
import { PageTitle } from './common/page-title'
import { CARD_BODY_COLUMN_DESCRIPTION } from '../helpers/card-body-column-description'
import { useNavigate } from 'react-router-dom'
import { ClientContext } from '../context/client-context'
import { loginButtonClassName } from '../helpers/resolve-tenant'
import InputSmsCode from './common/InputSmsCode'
import { RetryCode } from './common/retry-code'
import { Disclaimer } from './common/disclaimer'

function ResetPassword () {
  const codeSent = sessionStorage.getItem('code_sent')
  const { tenant } = useContext(ClientContext)
  const [error, setError] = useState(null)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [emailCode, setEmailCode] = useState('')
  const [validEmailCode, setValidEmailCode] = useState(false)

  const queryParams = new URLSearchParams(window.location.search)
  const queryEmail = queryParams.get('email')
  const showPasswordChangeNeededMessage = queryParams.get('passwordChangeNeeded')
  const migratedUserMessage = queryParams.get('migratedUser')
  const setPassword = queryParams.get('setPassword') === 'true'
  const socialAccount = queryParams.get('socialAccount') === 'true'

  const pageTitle = setPassword || socialAccount
    ? 'Crea tu contraseña'
    : 'Confirma tu correo electrónico'
  const pageSubtitle = setPassword || socialAccount
    ? 'Acceso con correo'
    : 'Recuperar contraseña'
  const codeLabelPrefix = setPassword || socialAccount
    ? 'Para crear tu contraseña te enviamos un código a'
    : 'Te enviamos un código de acceso al correo'

  useEffect(() => {
    if (!queryEmail) navigate('/', { replace: true })
    if (!queryEmail || codeSent) return
    sessionStorage.setItem('code_sent', 'true')
    PasswordService().verifyEmailResetPassword({ email: queryEmail }).then()
  }, [])

  const buildChangePasswordPath = (code) => {
    const params = new URLSearchParams({
      email: queryEmail,
      code
    })
    if (migratedUserMessage) params.set('migratedUser', 'true')
    if (showPasswordChangeNeededMessage) params.set('passwordChangeNeeded', 'true')
    if (setPassword) params.set('setPassword', 'true')
    if (socialAccount) params.set('socialAccount', 'true')
    return `/changepassword?${params.toString()}`
  }

  const submitEmailCode = async (code) => {
    if (loading) return
    setLoading(true)
    try {
      await PasswordService().validateEmailCode({ email: queryEmail, code })
      sessionStorage.removeItem('code_sent')
      navigate(buildChangePasswordPath(code), { replace: true })
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }

  const sendEmailCode = async () => {
    if (loading) return
    setLoading(true)
    try {
      await PasswordService().verifyEmailResetPassword({ email: queryEmail })
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <PageTitle title={pageTitle} subtitle={pageSubtitle}/>
      <SsoCard>
        <div className="row justify-content-center">
          <div className={`${CARD_BODY_COLUMN_DESCRIPTION} mb-2`}>
            {socialAccount && (
              <div className="alert alert-info fade show col-12" role="alert" style={{ fontSize: '13px' }}>
                Esta cuenta se creó con Google u otra red social. Crea una contraseña para poder iniciar sesión también con tu correo.
              </div>
            )}
            {error &&
              <ErrorAlert
                onCloseAlert={() => setError(null)}
                message={error.message} />
            }
          </div>
          <form
            style={{ color: '#64748B' }}
            onSubmit={e => {
              e.preventDefault()
              submitEmailCode(emailCode).then()
            }}
            className={`${CARD_BODY_COLUMN_DESCRIPTION}`}>
            <InputSmsCode
              showChangeEmail={true}
              disabled={loading}
              label={<>{codeLabelPrefix} <strong>{queryEmail}</strong></>}
              setSmsCode={setEmailCode}
              setValidSmsCode={setValidEmailCode} />
            <button type="submit" name="submit" hidden/>
          </form>
          <RetryCode resendCode={sendEmailCode}/>
          <div className={CARD_BODY_COLUMN_DESCRIPTION}>
            <button
              className={loginButtonClassName(tenant)}
              disabled={!validEmailCode || loading}
              onClick={() => submitEmailCode(emailCode)}>
              {loading && <span className="spinner-border spinner-border-sm" style={{ marginRight: '6px' }} role="status" aria-hidden="true"></span>}
              Continuar
            </button>
          </div>
          <Disclaimer initialMessage={'Al ingresar'} />
        </div>
      </SsoCard>
    </>
  )
}

export default ResetPassword
